import { ArrowDown } from "lucide-react";
import "../about/about-styles.css";

const features = [
  {
    title: "Storage",
    image: "assets/img/illustrations/illustration-9.png",
    text: "Keep all your business data organized and accessible in one safe place and back up your most important information and data with one click.",
  },
  {
    title: "Collaboration",
    image: "assets/img/illustrations/illustration-8.png",
    text: "Accelerate productivity with microtechnology solutions and tools that are connected and accessible to all employees working within your organization.",
  },
  {
    title: "Analytics",
    image: "assets/img/illustrations/illustration-7.png",
    text: "See what's happening in your company from a centralized dashboard. Remove all your business productivity dependencies.",
  },
  {
    title: "Permissions",
    image: "assets/img/illustrations/illustration-6.png",
    text: "Control who has access to which applications and data through our user management configuration tool and disable user access in real time whenever the need arises.",
  },
];

export default function AboutSection() {
  const scrollToSection = () => {
    const aboutSection = document.getElementById("about");
    aboutSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="about-section" id="about">
      {/* Scroll Arrow Button */}
      <div className="scroll-arrow-wrapper">
        <button
          onClick={scrollToSection}
          className="scroll-arrow-btn"
          aria-label="Scroll to about section"
        >
          <ArrowDown className="arrow-icon" />
        </button>
      </div>

      <div className="container">
        {/* Header Section */}
        <div className="section-header">
          <h2 className="section-title">
            Converge your{" "}
            <span className="highlight">Business Applications</span>
          </h2>
          <p className="section-description">
            SingleLogin lets you work seamlessly in a streamlined manner so that
            you can get work done efficiently and securely.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <FeatureCard key={feature.title} feature={feature} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureCard({ feature, index }) {
  return (
    <div
      className="feature-item"
      style={{
        animationDelay: `${index * 100}ms`,
      }}
    >
      <div className="feature-card">
        {/* Feature Image */}
        <div className="feature-image-wrapper">
          <div className="feature-image-container">
            <img
              src={feature.image || "/placeholder.svg"}
              alt={`${feature.title} illustration`}
              width={80}
              height={80}
              className="feature-image"
            />
          </div>
        </div>

        {/* Feature Content */}
        <div className="feature-content">
          <h3 className="feature-title">{feature.title}</h3>
          <p className="feature-text">{feature.text}</p>
        </div>
      </div>
    </div>
  );
}
